const FALLBACK_LOCALE = 'en-GB';
export const constructLocale = ({ langCode, countryCode }) => {
    if (langCode.includes('-')) {
        throw new Error('Invalid language code');
    }
    if (countryCode.includes('-')) {
        throw new Error('Invalid country code');
    }
    if (!langCode) {
        throw new Error('Missing language code');
    }
    if (!countryCode) {
        throw new Error('Missing country code');
    }
    return `${langCode.toLowerCase()}-${countryCode.toUpperCase()}`;
};
export const parseLocale = (locale) => {
    const [langCode = '', countryCode = ''] = locale.split('-');
    return {
        langCode: langCode,
        countryCode: countryCode
    };
};
export const parseLocaleStringInput = (localeString) => {
    const [langCodeRaw = '', countryCodeRaw = ''] = localeString.split('-');
    return parseLocale(constructLocale({ langCode: langCodeRaw, countryCode: countryCodeRaw }));
};
const getLocaleFromSearchParams = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const localeString = searchParams.get('locale');
    if (!localeString) {
        return null;
    }
    const [langCodeRaw = '', countryCodeRaw = ''] = localeString.split('-');
    return constructLocale({ langCode: langCodeRaw, countryCode: countryCodeRaw });
};
const getLocaleFromPath = () => {
    const match = window.location.pathname.match(/\/([a-z]{2})\/([a-z]{2})\//);
    if (!match) {
        return null;
    }
    const [_, countryCode = '', langCode = ''] = match;
    return constructLocale({ langCode, countryCode });
};
/**
 * Parses the locale from the query parameter and returns it if it exists
 */
export const getLocale = () => getLocaleFromSearchParams() ?? getLocaleFromPath() ?? FALLBACK_LOCALE;
export const getParsedLocale = () => parseLocale(getLocale());
export const getCountry = (locale = getLocale()) => parseLocale(locale).countryCode;
export const getLanguage = (locale = getLocale()) => parseLocale(locale).langCode;
/*
 * Get locale with possible language override
 */
export const getCustomLocale = (langCode) => {
    const { langCode: lc, countryCode } = getParsedLocale();
    return constructLocale({ langCode: langCode ?? lc, countryCode });
};
/**
 * Get the font language code for IKEA font loading.
 * Handles Chinese variants with proper script extensions.
 */
export const getFontLanguage = (locale = getLocale()) => {
    const language = getLanguage(locale);
    const country = getCountry(locale);
    // Handle Chinese variants with script extensions
    if (language === 'zh') {
        // Simplified Chinese (mainland China, Singapore)
        if (country === 'CN' || country === 'SG') {
            return 'zh-Hans';
        }
        // Traditional Chinese (Taiwan, Hong Kong)
        if (country === 'TW' || country === 'HK') {
            return 'zh-Hant';
        }
        // Default to simplified
        return 'zh-Hans';
    }
    return language;
};
/**
 * Check if market is North American
 */
export const isNAMarket = () => ['US', 'CA', 'DO', 'MX', 'PR'].includes(getCountry());
//# sourceMappingURL=i18nUtils.js.map